import {UserModel} from '@core/api/data-access';
import {withErrorState} from '@shared-types';

import {signalStoreDefinition} from '../';

export type UserState<U extends UserModel = UserModel> = U & WithId;

export const UsersStore = signalStoreDefinition({
	...withErrorState,
	lastCall: null as Date,
	users: null as Record<string, UserState>,
	isLoading: false,
	isLoaded: false,
	isError: false,
});

export default UsersStore;
